import { useContext } from 'react';
import { DropdownMenuContext } from './DropdownMenuContext.js';

var DropdownButtonChildren = function DropdownButtonChildren(_a) {
  var children = _a.children;
  var dropdownState = useContext(DropdownMenuContext).dropdownState;
  if (dropdownState.menuVisible) return children;
  return null;
};

export default DropdownButtonChildren;